import React, { ReactNode, useContext, useState } from 'react'

import { DataResultTemplate } from '@/@types/global'

interface DocumentApprovalContextInterface {
  templateColumnResult: DataResultTemplate[]
  setTemplateColumnResult: (value: DataResultTemplate[]) => void
  templateRowResult: DataResultTemplate[]
  setTemplateRowResult: (value: DataResultTemplate[]) => void
  itemsResult: any[] | undefined
  setItemsResult: (value: any[] | undefined) => void
  isRealoadItemsResult: boolean
  setIsRealoadItemsResult: (value: boolean) => void
}

export const DocumentApprovalContext =
  React.createContext<DocumentApprovalContextInterface>(
    {} as DocumentApprovalContextInterface
  )

interface DocumentApprovalProviderProps {
  children: ReactNode
}

const DocumentApprovalProvider = ({
  children,
}: DocumentApprovalProviderProps) => {
  const [templateColumnResult, setTemplateColumnResult] = useState<
    DataResultTemplate[]
  >([])
  const [templateRowResult, setTemplateRowResult] = useState<
    DataResultTemplate[]
  >([])
  const [itemsResult, setItemsResult] = useState<any[] | undefined>(undefined)
  const [isRealoadItemsResult, setIsRealoadItemsResult] =
    useState<boolean>(false)

  return (
    <DocumentApprovalContext.Provider
      value={{
        templateColumnResult,
        setTemplateColumnResult,
        templateRowResult,
        setTemplateRowResult,
        itemsResult,
        setItemsResult,
        isRealoadItemsResult,
        setIsRealoadItemsResult,
      }}
    >
      {children}
    </DocumentApprovalContext.Provider>
  )
}

function useDocumentApproval(): DocumentApprovalContextInterface {
  return useContext(DocumentApprovalContext)
}

export { DocumentApprovalProvider, useDocumentApproval }
